import { render } from "./SubmitButton.vue?vue&type=template&id=e5c33276"
import script from "./SubmitButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/form/SubmitButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5c33276"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5c33276', __exports__)) {
    api.reload('e5c33276', __exports__)
  }
  
  module.hot.accept("./SubmitButton.vue?vue&type=template&id=e5c33276", () => {
    api.rerender('e5c33276', render)
  })

}


export default __exports__